import { VideoSettings } from '@/stores/video_settings/video_settings';

import Alpine from 'alpinejs';

Alpine.store('videoSettings', new VideoSettings());
